/**
 * @generated SignedSource<<e7a5a2c8bceb7755eaa2545f8f65cdd1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespAboutItemPanelItemModuleDetails_user$data = {
  readonly preferences: {
    readonly measurementUnit: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailFramingOptions_user" | "PdpSharedDetailReference_user">;
  readonly " $fragmentType": "PdpRespAboutItemPanelItemModuleDetails_user";
};
export type PdpRespAboutItemPanelItemModuleDetails_user$key = {
  readonly " $data"?: PdpRespAboutItemPanelItemModuleDetails_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutItemPanelItemModuleDetails_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespAboutItemPanelItemModuleDetails_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserPreferences",
      "kind": "LinkedField",
      "name": "preferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "measurementUnit",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailFramingOptions_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailReference_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "39eea0f39afe3405f450dace226dc374";

export default node;
